import React from 'react'
import {
  LinkedOrganization,
  TailoredProduct,
} from 'services/api/entities/catalog/types'
import { FilterSelectInput } from 'ui-shared/FilterSelectInput'
import { KFilterFieldProps } from 'ui-shared/KFilters'
import { useFormContext } from 'react-hook-form'
import { FILTER_SOURCES } from 'services/cfg/filter'

const TailoredOrganizationFilter: React.FC<KFilterFieldProps> = ({
  entity,
  source,
  label,
  ...props
}) => {
  const { getValues, setValue } = useFormContext()

  const handleChange = () => {
    if (getValues(FILTER_SOURCES.visibleToAll)) {
      setValue(FILTER_SOURCES.visibleToAll, '')
    }
  }

  return (
    <FilterSelectInput<LinkedOrganization>
      {...props}
      entity={entity}
      label={label}
      searchFn={(e: TailoredProduct) => e.organizationsFull}
      optionText="name"
      source={source}
      onChange={handleChange}
    />
  )
}

export default TailoredOrganizationFilter
